<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
    style="width:100%">
    <thead>
      <tr>

        <th class="disabled-sorting"><b>Id</b></th>
        <th class="disabled-sorting"><b>Name</b></th>
        <th class="disabled-sorting"><b>Description</b></th>
        <th class="disabled-sorting"><b>Width Limit</b></th>
        <th class="disabled-sorting"><b>Type</b></th>
        <th class="disabled-sorting text-right"><b>Actions</b></th>

      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer;" *ngFor="let item of data">

        <td>{{item.id}}</td>
        <td>{{item.locationRow}}-{{item.locationBay}}-{{item.locationLevel}}-{{item.locationSection}}</td>
        <td>{{item.locationName}}</td>
        <td>{{item.maxWeightLimit}}</td>
        <td>{{item.type.name}}</td>
        
        <td class="text-right">
          <a class="btn btn-link btn-success btn-just-icon like" (click)="saveEmit('reserved',item.id, item)">
            <i class="material-icons">event_seat</i>
          </a>
          <a class="btn btn-link btn-warning btn-just-icon like" (click)="saveEmit('list',item.id, item)">
            <i class="material-icons">format_list_numbered</i>
          </a>
          <a class="btn btn-link btn-primary btn-just-icon like" (click)="saveEmit('print',item.id, item)">
            <i class="material-icons">print</i>
          </a>
          <a class="btn btn-link btn-info btn-just-icon like" (click)="saveEmit('show',item.id, item)">
            <i class="material-icons">remove_red_eye</i>
          </a>
          <a class="btn btn-link btn-danger btn-just-icon" (click)="saveEmit('delete',item.id, item)">
            <i class="material-icons">close</i>
          </a>
        </td>
       
      </tr>
    </tbody>

  </table>
</div>